"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _selectors = require("../redux/selectors");
var _actions = require("../redux/actions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useHandleActionDevice = props => {
  const {
    thingPDIDDevice = null
  } = props;
  const [hovered, setHover] = (0, _react.useState)(false);
  const api = (0, _drei.useBounds)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const selectedPoint = (0, _reactRedux.useSelector)(_selectors.getSelectedPoint);
  const pointNotSelected = (0, _react.useCallback)(() => !selectedPoint || (selectedPoint === null || selectedPoint === void 0 ? void 0 : selectedPoint.thingPDIDDevice) !== thingPDIDDevice, [selectedPoint, thingPDIDDevice]);
  (0, _drei.useCursor)(hovered);
  const handleClick = (0, _react.useCallback)(e => {
    e.stopPropagation();
    if (pointNotSelected()) {
      e.delta <= 2 && api.refresh(e.eventObject.parent).clip().fit();
      dispatch((0, _actions.setSelectedPoint)({
        thingPDIDDevice
      }));
    } else {
      e.button === 0 && api.refresh().fit();
      dispatch((0, _actions.setSelectedPoint)(null));
    }
  }, [pointNotSelected, dispatch, thingPDIDDevice]);
  const handlePointerMissed = (0, _react.useCallback)(e => {
    var _e$target;
    setHover(false);
    if (!pointNotSelected() && !(e !== null && e !== void 0 && (_e$target = e.target) !== null && _e$target !== void 0 && _e$target.closest('.clickable-area'))) {
      e.button === 0 && api.refresh().fit();
      dispatch((0, _actions.setSelectedPoint)(null));
    }
  }, [pointNotSelected, dispatch, thingPDIDDevice]);
  const handlePointerOver = (0, _react.useCallback)(e => {
    e.stopPropagation();
    setHover(true);
  }, []);
  const handlePointerOut = (0, _react.useCallback)(() => {
    setHover(false);
  }, []);
  return {
    handleClick,
    handlePointerOut,
    handlePointerOver,
    handlePointerMissed
  };
};
var _default = exports.default = useHandleActionDevice;